import React, { useState, useEffect } from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';

const SearchBar = ({ value, onChange, placeholder = "Search projects...", compact = false }) => {
    const [localValue, setLocalValue] = useState(value);

    // Debounce: Wait 300ms after user stops typing
    useEffect(() => {
        const timer = setTimeout(() => {
            onChange(localValue);
        }, 300);

        return () => clearTimeout(timer);
    }, [localValue, onChange]);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const handleClear = () => {
        setLocalValue("");
        onChange("");
    };

    return (
        <div className="relative w-full">
            <div className="relative">
                <FaSearch
                    className={`absolute top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none ${compact ? 'left-3 w-3 h-3' : 'left-4'}`}
                    aria-hidden="true"
                />
                <input
                    type="text"
                    value={localValue}
                    onChange={(e) => setLocalValue(e.target.value)}
                    placeholder={placeholder}
                    className={`w-full rounded-xl bg-gray-50/80 border border-gray-200
                               focus:bg-white focus:outline-none focus:ring-2 focus:ring-designer-primary/40
                               focus:border-designer-primary/40 text-designer-dark placeholder-gray-400 transition-all duration-300 ${
                                 compact ? 'pl-9 pr-9 py-2 text-sm' : 'pl-12 pr-12 py-3'
                               }`}
                    aria-label="Search"
                />
                {localValue && (
                    <button
                        onClick={handleClear}
                        className={`absolute top-1/2 -translate-y-1/2 text-gray-400 hover:text-designer-primary
                                   transition-colors focus:outline-none focus:ring-2 focus:ring-designer-primary rounded-full p-1 ${
                                     compact ? 'right-3' : 'right-4'
                                   }`}
                        aria-label="Clear search"
                    >
                        <FaTimes className={compact ? 'w-3 h-3' : ''} />
                    </button>
                )}
            </div>
        </div>
    );
};

export default SearchBar;
